import React from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import HomeComponent from "./pages/HomeComponent";
import LoginComponent from "./pages/LoginComponent";
import {AuthProvider} from "./contexts/AuthContext";
import PrimarySearchAppBar from "./components/NavbarComponent";
import PrivateRoute from "./components/PrivateRoute";
import AdminPrivateRoute from "./components/AdminPrivateRoute";
import {GroupProvider} from "./contexts/GroupContext";
import AboutComponent from "./pages/AboutComponent";
import HelpComponent from "./pages/HelpComponent";
import SignupComponent from "./pages/SignupComponent";
import AdminComponent from "./pages/AdminComponent";
import {Box, Container} from "@mui/material";

window.React = React


//Theme
function App() {
    //TODO: some of these values may need to be split and distributed more specifically
    //Top bar bg and actual page bg defined in App.css

    //Older gray/black theme
    // const buttonColor = '#3131F4'
    // const accordionHeaderColor = '#44446B'
    // const colorAccent = '#F4F7F9'
    // const colorBackgroundTwo = '#616161'
    // const colorBackgroundThree = '#414142'
    // const colorBackground = '#000000'

    //White component background
    const buttonColor = '#3131F4'
    const accordionHeaderColor = '#3131F4'
    const colorAccent = '#000000'
    const colorAccentSecondary = '#FFFFFF'
    const colorBackgroundTwo = '#FFFFFF'
    const colorBackgroundThree = '#F4F7F9'
    const colorBackground = '#000000'
    const colorAppBar = '#FFFFFF'
    const colorSelectedBot = '#76ff03' //"#79b947" : "#4393b6"
    const colorOtherBot = '#40c4ff'
    const colorLoadingBackground = '#3131F4'//'#515165'
    const colorGoalDivider = '#00000070'
    const colorGoalSubDivider = '#00000012'
    //TODO: Comment throughout createTheme what each override is actually changing (in terms of elements on the page)
    const theme = createTheme({
        //TODO: Another route to go for coverage, override all of (total 18):
        //  Colors: primary, secondary, error, warning, info, success
        //  Types: light, main, dark
        // (Also define contrastText? - used alongside constrastThreshold and tonalOffset)
        palette: {
            text: {
                primary: colorAccent,
                secondary: colorBackground
            },
            custom: {
                background: colorBackground,
                backgroundTwo: colorBackgroundTwo,
                backgroundThree: colorBackgroundThree,
                accent: colorAccent,
                button: buttonColor,
                selectedBot: colorSelectedBot,
                otherBot: colorOtherBot,
                loadingBackground: colorLoadingBackground,
                goalDivider: colorGoalDivider,
                goalSubDivider: colorGoalSubDivider
            }
        },
        //Themes for specific material-ui components can be set here
        components: {
            //  Override defaultProps to change the default props for a specific element
            // MuiButtonBase: {
            //     defaultProps: {
            //         disableRipple: true, // No more ripple, on the whole application 💣!
            //     },
            // },
            //Use styleOverrides to do the same for style
            //  Look at CSS section of corresponding component's API to see list of what to change
            MuiButton: {
                styleOverrides: {
                    root: ({ownerState}) => ({
                        //Can use ownerState object to inspect variant, color, etc
                        backgroundColor: buttonColor,
                        color: colorAccentSecondary,
                        '&:hover': {
                            backgroundColor: buttonColor,
                            color: colorAccentSecondary,
                        }
                    }),
                }
            },
            MuiAccordionSummary: {
                styleOverrides: {
                    root: {
                        backgroundColor: accordionHeaderColor,
                        borderRadius: '4px',
                        '&.Mui-expanded': {
                            borderBottomLeftRadius: '0px',
                            borderBottomRightRadius: '0px',
                        }
                    }
                },
                variants: [
                    {
                        props: {color: 'subHeader'},
                        style: {
                            backgroundColor: colorBackgroundThree,
                        }
                    }
                ]
            },
            MuiAccordion: {
                styleOverrides: {
                    root: {
                        '&.Mui-expanded': {
                            margin: 0
                        },
                        '&:before': {
                            backgroundColor: colorBackgroundTwo
                        }
                    }
                }
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        'color': colorAccent,
                        '&.Mui-disabled': {
                            'color': colorBackgroundThree
                        }
                    }
                }
            },
            //EW: believe not
            //TODO: how to interleave styleOverrides and variants? Is this possible for inner children of other
            //      Mui components?
            //TextField Styling
            MuiInput: {
                styleOverrides: {
                    root: {
                        //underline color before any interaction
                        "&::before": {
                            borderBottom: '1px solid ' + colorAccent
                        },
                        //underline color in focus
                        "&::after": {
                            borderBottom: '1px solid ' + colorAccent
                        },
                        //cursor and text color in input field
                        color: colorAccent,
                        '&.Mui-disabled': {
                            color: colorBackgroundThree
                        }
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        "& .MuiInputLabel-root": {
                            color: colorAccent,
                            right: 0,
                            textAlign: "center"
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                            right: 0,
                            textAlign: "start"
                        },
                        "& .MuiInputLabel-shrink": {
                            right: 0,
                            textAlign: "start"
                        },
                    }
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        //color of label when empty
                        color: colorAccent,
                        //color of label when focused
                        "&.Mui-focused": {
                            color: colorAccent
                        }
                    }
                },
                variants: [
                    {
                        props: {variant: 'custom'},
                        style: {
                            color: colorBackground,
                        }
                    }
                ]
            },
            MuiInputBase: {
                styleOverrides: {
                    //Selected item in select components (or within textFields)
                    input: {
                        color: colorAccent,
                        textAlign: 'center',
                    }
                },
                variants: [
                    {
                        props: {color: 'secondary'},
                        style: {
                            color: colorBackground
                        }
                    }
                ]
            },
            //Paper styling
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundColor: colorBackgroundTwo,
                        borderRadius: '5px !important',
                        '&:last-of-type': {
                            borderRadius: '5px !important',
                        },
                        '&:first-of-type': {
                            borderRadius: '5px !important',
                        }
                    },
                },
            },
            MuiTableSortLabel: {
                styleOverrides: {
                    icon: {
                       color: colorAccent,
                    },
                    root: {
                        color: colorAccent,
                        '&.Mui-active .MuiTableSortLabel-icon': {
                            color: colorAccent
                        },
                        '&.Mui-active': {
                            color: colorAccent
                        }
                    }
                }
            },
            MuiBadge: {
                styleOverrides: {
                    badge: {
                        color: colorAccentSecondary,
                        backgroundColor: colorAccent
                    }
                }
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        color: colorAccent,
                    }
                }
            },
            MuiTableRow: {
                styleOverrides: {
                    root: {
                        '& td': {
                            borderBottom: '1px solid ' + colorGoalDivider
                            // border: "0"
                        },
                        '& th': {
                            borderBottom: '1px solid ' + colorGoalDivider
                        },
                        '&:last-child td': {
                            border: 0
                        },
                    }
                }
            },
            MuiAppBar: {
                styleOverrides: {
                    colorPrimary: {
                        backgroundColor: colorAppBar
                    }
                }
            },
            MuiTypography: {
                styleOverrides: {
                    root: {
                        color: colorAccent,
                    }
                },
                variants: [
                    {
                        props: {color: 'accordionHeader'},
                        style: {
                            color: colorAccentSecondary,
                            textShadow: '2px 2px 10px black'
                        }
                    }
                ]
            },
            MuiDialogContentText: {
                styleOverrides: {
                    root: {
                        color: colorAccent,
                        paddingBottom: 10
                    }
                }
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        color: colorAccentSecondary,
                        backgroundColor: colorBackground,
                        '&.Mui-selected': {
                            color: colorAccent,
                            backgroundColor: colorAccentSecondary,
                        },
                        '&:hover': {
                            color: colorAccent,
                            backgroundColor: colorBackgroundThree,
                        }
                    }
                },
                variants: [
                    {
                        props: {color: 'secondary'},
                        style: {
                            color: colorAccent,
                            backgroundColor: colorBackgroundTwo,
                            '&.Mui-selected': {
                                color: colorBackground,
                                backgroundColor: colorAccent,
                            }
                        }
                    }
                ]
            },
            MuiMenu: {
                styleOverrides: {
                    list: {
                        paddingTop: 0,
                        paddingBottom: 0,
                        display: 'grid'
                    }
                }
            },
            MuiList: {
                styleOverrides: {
                    root: {
                        paddingTop: 0,
                        paddingBottom: 0
                    }
                }
            },
            MuiContainer: {
                styleOverrides: {
                    root: {
                        //Default Paper elements within a container
                        '& .MuiPaper-root': {
                            backgroundColor: colorBackgroundTwo
                        },
                        //variant custom Paper elements within a container
                        '& .MuiPaper-root.MuiPaper-button': {
                            backgroundColor: buttonColor,
                            textAlign: 'left',
                            color: colorAccent,
                            padding: 2
                        },
                        //Svg icons in containers (spinner dropdowns, send buttons, pause/play/cancel, etc.)
                        '& .MuiSvgIcon-root': {
                            color: colorAccentSecondary
                        },
                        '& .MuiSvgIcon-root.MuiSvgIcon-colorAlt': {
                            color: colorAccent
                        },
                        '&.ForwardRef\(IconButton\)-root-336 svg': {
                            background: 'transparent'
                        },
                        //Svg icons in containers when supplied color="send"
                        '& .MuiSvgIcon-root.MuiSvgIcon-colorSend': {
                            color: buttonColor
                        },
                        '& .MuiDivider-root': {
                            backgroundColor: colorBackgroundTwo,
                            width: '100%',
                        },
                        '& .MuiGrid-root': {
                            alignItems: 'center'
                        },
                    }
                },
            },
            //Side drawer background color
            MuiDrawer: {
                styleOverrides: {
                    paper: {
                        backgroundColor: colorBackgroundTwo + ' !important'
                    }
                }
            },
            MuiSelect: {
                styleOverrides: {
                    select: {
                        '&MuiInputBase-input-MuiInput-input.MuiSelect-select': {
                            color: colorBackground
                        }
                    },
                    icon: {
                        color: colorAccent + ' !important'
                    }
                }
            },
            MuiAccordionDetails: {
                styleOverrides: {
                    root: {
                        padding: 0
                    }
                }
            },
            MuiTableContainer: {
                styleOverrides: {
                    root: {
                        overflowX: 'unset'
                    }
                }
            }
        },
        typography: {
            fontFamily: "Space Grotesk, sans-serif",
            fontSize: '14'
        }
    });

    //Also font options for things like 'button' and 'caption'
    //Apply typography by supplying e.g. variant="h1"
    //TODO: why does this need important to apply to certain elements?
    theme.typography.h1 = {
        fontSize: '1.6rem !important',
        fontWeight: "normal !important",
        fontFamily: "Space Grotesk, sans-serif !important",
    };
    theme.typography.h2 = {
        fontSize: '2.0rem !important',
        fontFamily: "Space Grotesk, sans-serif !important",
    };
    theme.typography.h3 = {
        fontSize: '1.5rem !important',
        fontFamily: "Space Grotesk, sans-serif !important",

    };
    theme.typography.h4 = {
        fontSize: '1.2rem !important',
        fontFamily: "Space Grotesk, sans-serif !important",
    };
    theme.typography.h6 = {
        fontSize: '1.2rem !important',
        fontFamily: "Space Grotesk, sans-serif !important",
    };
    //Default factor is 8; 8*2=16px
    //Define spacing in createTheme above to change the factor (e.g. spacing:4 -> 4*2=8px)
    //Can also be reactive; spacing: (factor) => `${0.25 * factor}rem`
    //      = .25 * 2rem = 0.5rem = 8px
    theme.spacing(2);

    return (
        <section className="App">
            <AuthProvider>
                <GroupProvider>
                    <Router>
                        <ThemeProvider theme={theme}>
                            <PrimarySearchAppBar/>
                            <Box m={10}/>
                            <Container maxWidth="lg">
                                <Switch>
                                    <PrivateRoute exact path="/" component={HomeComponent}/>
                                    <AdminPrivateRoute exact path="/admin" component={AdminComponent}/>
                                    <Route path="/login" component={LoginComponent}/>
                                    <Route path="/signup" component={SignupComponent}/>
                                    <Route path="/help" component={HelpComponent}/>
                                    <Route path="/about" component={AboutComponent}/>
                                </Switch>
                            </Container>
                        </ThemeProvider>
                    </Router>
                </GroupProvider>
            </AuthProvider>
        </section>
    );
}

export default App;
